import { Divider, Radio } from 'antd'
import { nanoid } from 'nanoid'
import React, { useContext, useEffect, useState } from 'react'
import { MdOutlineCheck } from 'react-icons/md'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { setSector, setSubSector } from '../../../../redux/reducers/talentSlice'
import { FeathersContext } from '../../../../services/feathers'
import { capitalizeAllWords } from '../../../../utils/utils'
import Experience from '../../Profile/ProfileForm/Fields/Experience/Experience'

const SectorStep = () => {
  const feathers = useContext(FeathersContext)
  const { sector, subSector } = useSelector((state) => state.talent)

  const dispatch = useDispatch()
  const [subSectorChoices, setSubSectorChoices] = useState([])

  const { data: sectors } = useQuery({
    queryFn: async () => {
      const response = await feathers.service('sectors').find({
        query: {
          $limit: 20,
          $sort: {
            name: 1,
          },
        },
      })

      return response.data
    },
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (sector?.length && sectors?.length) {
      const sectorFiltered = sectors?.filter((sr) => sr.name === sector)

      if (sectorFiltered[0]?.subSectors?.length) {
        setSubSectorChoices(sectorFiltered[0].subSectors)
      } else {
        setSubSectorChoices([])
      }
    }
  }, [sectors, sector])

  return (
    <div>
      <div className="step-content">
        <div>
          <label className="field-label">Secteurs</label>
          <Radio.Group
            onChange={(e) => {
              dispatch(setSector(e.target.value))
              dispatch(setSubSector(''))
              setSubSectorChoices([])
            }}
            defaultValue={sector}
          >
            {sectors
              ?.map((sector) => sector.name)
              .map((sector) => (
                <Radio key={nanoid()} value={sector}>
                  {capitalizeAllWords(sector.toLowerCase())}
                </Radio>
              ))}
          </Radio.Group>
          <div
            style={{ margin: '2rem 0' }}
            className={`transition ${
              subSectorChoices?.length ? 'transition-fade' : 'transition-hidden'
            }`}
          >
            {subSectorChoices?.length > 0 && (
              <>
                <Radio.Group
                  className="special"
                  onChange={(e) => {
                    dispatch(setSubSector(e.target.value))
                  }}
                  defaultValue={subSector}
                >
                  {subSectorChoices.map((sc) => (
                    <Radio.Button key={nanoid()} value={sc}>
                      {sc === subSector ? (
                        <MdOutlineCheck size={20} />
                      ) : (
                        <MdOutlineCheck size={20} color="white" />
                      )}
                      {sc}
                    </Radio.Button>
                  ))}
                </Radio.Group>
              </>
            )}
          </div>
          {/* <h1 className="text-center">2/4 - {t('common:table.jobdomain')}</h1> */}
          <Divider style={{ margin: '3rem 0' }} />
          <Experience />
        </div>
      </div>
    </div>
  )
}

export default SectorStep
